<template>
  <div id="device-serial-setup">
    <v-form ref="device_serial_validation_form">
      <v-text-field
        v-model="serial"
        class="rounded_8px height_56px settings_textfield"
        :placeholder="$i18n.t('pages.system.device_serial_settings.device_serial')"
        outlined
        :rules="validation_rules.storage_period"
        @change="set_device_serial(serial)"
      />
    </v-form>
  </div>
</template>

<script>
import {i18n} from "@/i18n";
import {mapActions, mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "DeviceSerialSetup",
  data: function () {
    // this.fetch_data()
    return {
      old_serial: store.getters.systemParams.serial,
      validation_rules: {
        storage_period: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            () => this.is_normal_integer(this.systemParams.serial)|| i18n.t('validation.set_number_of_days')
        ]
      }
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    is_normal_integer: function (str) {
      return true
    },
    set_device_serial: function (serial) {
      if (!this.$refs.device_serial_validation_form.validate()) return
      let params = {
        serial: serial
      }
      let data = {params: params}
      this.$http({
        url: this.$http_hostname + '/system_settings/set_config_params',
        data: data,
        method: 'POST'
      })
      .then(() => {
        this.setSnackbar({
          text: i18n.t('notifications.system.device_serial_set') + '. ' +
              i18n.t('general.system_reboot_required')
        })
        this.updateLoadingOverlay({reload_required: true})
      })
      .catch(error => {
        console.log(error)
      })
    },
    ...mapActions(['setSnackbar', 'updateSystemParams', 'updateLoadingOverlay'])
  },
  computed: {
    serial: {
      get () {
        return this.systemParams.serial
      },
      set (value) {
        // this.set_device_serial(value)
        this.updateSystemParams({
          serial: value,
        })
      }
    },
    ...mapGetters(['systemParams'])
  },
  beforeDestroy() {
    if (!this.systemParams.serial) {
      this.updateSystemParams({
          serial: this.old_serial,
        })
    }
  }
}
</script>

<style scoped>

</style>